module.exports = __webpack_public_path__ + "img/left_bg.b628f5b8.png";